export const getOptimalChunkSize = (fileSize) => {
  const MB = 1024 * 1024;
  const MIN_CHUNK = 5 * MB;
  const MAX_PARTS = 10000;
  const MAX_CHUNK = 5 * 1024 * MB;
  
  let chunkSize = Math.ceil(fileSize / MAX_PARTS);

  chunkSize = Math.ceil(chunkSize / MB) * MB;

  if (chunkSize < MIN_CHUNK) chunkSize = MIN_CHUNK;

  if (chunkSize < 64 * MB) chunkSize = 64 * MB;

  if (chunkSize > MAX_CHUNK) chunkSize = MAX_CHUNK;

  return chunkSize;
};

export const sliceFileToMultiParts = (file, chunkSize) => {
  let finalChunkSize = chunkSize || getOptimalChunkSize(file.size);

  let totalParts = Math.ceil(file.size / finalChunkSize);

  if (totalParts > 10000) {
    finalChunkSize = Math.ceil(file.size / 10000);
    totalParts = Math.ceil(file.size / finalChunkSize);
  }

  const parts = [];

  for (let i = 0; i < totalParts; i++) {
    const start = i * finalChunkSize;
    const end = Math.min(start + finalChunkSize, file.size);

    parts.push({
      partNumber: i + 1,
      blob: file.slice(start, end),
      start,
      end,
    });
  }

  return parts;
};
